import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibraryApiService } from '@app/core/service/api/library.api.service';
import { AnnouncementItemModule } from '@app/modules/announcement-item/announcement-item.module';
import { AnnouncementThreadModule } from '@app/modules/announcement-thread/announcement-thread.module';
import { ContentTitleModule } from '@app/modules/content-title/content-title.module';
import { DirectivesModule } from '@app/modules/directives.module';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { MoodCheckQuestionModule } from '@app/modules/mood-check-question/mood-check-question.module';
import { NegativeFeedbackQuestionModule } from '@app/modules/negative-feedback-question/negative-feedback-question.module';
import { PositiveFeedbackQuestionModule } from '@app/modules/positive-feedback-question/positive-feedback-question.module';
import { RecognitionItemModule } from '@app/modules/recognition-item/recognition-item.module';
import { SurveyItemModule } from '@app/modules/survey-item/survey-item.module';
import { SurveyJsViewerComponent } from '@app/modules/surveyjs-viewer/surveyjs-viewer.component';
import { TeamEvaluationQuestionModule } from '@app/modules/team-evaluation-question/team-evaluation-question.module';
import { WysiwygEditorComponent } from '@app/modules/wysiwyg-editor/wysiwyg-editor.component';
import { AnnouncementAcknowledgeButtonTextPipe } from '@app/pipes/standalone/announcement-acknowledge-button-text.pipe';
import { AnnouncementRespondButtonTextPipe } from '@app/pipes/standalone/announcement-respond-button-text.pipe';
import { IonicModule } from '@ionic/angular';
import { AnnouncementPreviewComponent } from './components/announcement-preview/announcement-preview.component';
import { SurveyPreviewComponent } from './components/survey-preview/survey-preview.component';
import { WhatsNewItemComponent } from './components/whats-new-item/whats-new-item.component';
import { WhatsNewModalComponent } from './whats-new-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    AnnouncementItemModule,
    RecognitionItemModule,
    SurveyItemModule,
    WysiwygEditorComponent,
    AnnouncementThreadModule,
    PositiveFeedbackQuestionModule,
    NegativeFeedbackQuestionModule,
    MoodCheckQuestionModule,
    TeamEvaluationQuestionModule,
    FullHeightContainerModule,
    ContentTitleModule,
    AnnouncementAcknowledgeButtonTextPipe,
    AnnouncementRespondButtonTextPipe,
    SurveyJsViewerComponent
  ],
  exports: [WhatsNewModalComponent],
  declarations: [
    WhatsNewModalComponent,
    AnnouncementPreviewComponent,
    SurveyPreviewComponent,
    WhatsNewItemComponent
  ],
  providers: [LibraryApiService]
})
export class WhatsNewModalModule {}
